import { render } from "./index.vue?vue&type=template&id=a349dba0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/default-layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a349dba0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a349dba0', __exports__)) {
    api.reload('a349dba0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a349dba0", () => {
    api.rerender('a349dba0', render)
  })

}


export default __exports__